import { FC } from "react";
import { StyleProp, StyleSheet, Text, TextProps, TextStyle } from "react-native";
import { kColors } from "src/kColors";

type tPdTextVariant =
  | "hero"
  | "h2"
  | "h3"
  | "h4"
  | "subheader"
  | "body-xs"
  | "body-sm"
  | "body"
  | "body-lg"
  | "fieldset";

export type tPdText = {
  variant?: tPdTextVariant;
} & TextProps;

const getVariantStyle = (variant: tPdTextVariant): StyleProp<TextStyle> => {
  if (variant === "hero") {
    return styles.hero;
  } else if (variant === "h2") {
    return styles.h2;
  } else if (variant === "h3") {
    return styles.h3;
  } else if (variant === "h4") {
    return styles.h4;
  } else if (variant === "subheader") {
    return styles.subheader;
  } else if (variant === "body-xs") {
    return styles.bodyXs;
  } else if (variant === "body-sm") {
    return styles.bodySm;
  } else if (variant === "body") {
    return styles.body;
  } else if (variant === "body-lg") {
    return styles.bodyLg;
  } else if (variant === "fieldset") {
    return styles.fieldset;
  }
  return {};
};

export const PdText: FC<tPdText> = ({ variant = "body", style, ...rest }) => {
  return <Text style={[getVariantStyle(variant), styles.pdText, style]} {...rest} />;
};

const styles = StyleSheet.create({
  body: {
    fontFamily: "Poppins",
    fontSize: 14,
    fontWeight: "300",
    letterSpacing: 1.2,
  },
  bodyLg: {
    fontFamily: "Poppins",
    fontSize: 16,
    fontWeight: "400",
    letterSpacing: 1.6,
  },
  bodySm: {
    fontFamily: "Poppins",
    fontSize: 12,
    fontWeight: "300",
    letterSpacing: 1.2,
  },
  bodyXs: {
    fontFamily: "Poppins",
    fontSize: 10,
    fontWeight: "300",
    letterSpacing: 1,
  },
  fieldset: {
    fontFamily: "Poppins",
    fontSize: 16,
    fontWeight: "400",
    letterSpacing: 0.8,
  },
  h2: {
    fontFamily: "Raleway",
    fontSize: 50,
    fontWeight: "500",
    letterSpacing: 0.8,
  },
  h3: {
    fontFamily: "Raleway",
    fontSize: 36,
    fontWeight: "500",
    letterSpacing: 0.8,
  },
  h4: {
    fontFamily: "Raleway",
    fontSize: 22,
    fontWeight: "600",
    letterSpacing: 1.2,
  },
  hero: {
    fontFamily: "Raleway",
    fontSize: 56,
    fontWeight: "500",
    letterSpacing: 1.6,
  },
  pdText: {
    color: kColors.brandDark,
  },
  subheader: {
    fontFamily: "Poppins",
    fontSize: 22,
    fontWeight: "400",
    letterSpacing: 2,
  },
});
